import React from 'react';

 const ModuleNavattic = ( props ) => {
const {navattic} = props; 
   const urlMatch = navattic.match(/src="([^"]+)"/);
   const url = urlMatch ? urlMatch[1] : null;
   if(!url) return null;
 return (
<div className="navattic">
<iframe
  src={`${url}`}
  title="Product Tour"
  width="100%"
  height="600"
  frameborder="0"
  allowFullScreen
  referrerPolicy="strict-origin-when-cross-origin"
></iframe></div>
      )};
 
export default ModuleNavattic;